import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import MemberList from './MemberList';
import SearchForm from '../../../../common/search/SearchForm';
import { Pagination, NoResults } from '../../../../common/elements';
import { PaginationHelpers } from '../../../../../helpers/';
import * as memberActions from '../../../../../actions/members/members';
import * as commonActions from '../../../../../actions/common/search';
import { Loader } from "../../../../common/elements/index";
import { siteOfOriginHelper } from './../../../../../helpers/genericHelpers';
import throttle from 'lodash/throttle';
import ThemePageBanner from "../../../../dashboardNew/components/ThemePageBanner";
import Anchor from "../../../../dashboardNew/objects/Anchor";
import { PrismicDocumentHelper } from '../../../../../helpers/prismicHelpers/PrismicHelpers';
import { membersPageHelper } from '../../../../../helpers/prismicHelpers/prismic-custom-helpers/MembersPageHelper';

class MemberPage extends Component {

	state = {
		membersInfo: ''
	}

	componentWillMount() {

		this.getMemberInfoPrismic();
		this.props.getMembers( this.getMemberSearchOpts(), this.props.location.query.page ? this.props.location.query.page : 1 );
		this.props.getLocations();
		this.props.getExpertise();
		this.props.getIndustries();
		this.props.getSectors();

	}

	async getMemberInfoPrismic(){
		const data = await PrismicDocumentHelper('document.type', 'members-page', false, 'at')
		const membersInfo = membersPageHelper(data);
		this.setState({ membersInfo })
	}

	getMemberSearchOpts(){
		return siteOfOriginHelper() === 'us' ? { country_id: "233", ...this.props.options } : { country_id: "77", ...this.props.options } ;
	}

	componentWillReceiveProps(nextProps, nextState) {
		if (this.props.location.query.page !== nextProps.location.query.page) {
			if(this.props.location.query.page === '1' && (nextProps.location.query.page === undefined || nextProps.location.query.page === '1')) {
				browserHistory.goBack(2);
			};
		};
	}

	componentWillUnmount() {
		this.props.unmountMembers();
	}

	clearSearchForm( ev ) {
		ev.preventDefault();
		if( this.props.formValues.values ) { this.props.formValues.values = null };
		browserHistory.push( `/members?page=1` );

		const opts = this.getMemberSearchOpts();
		Object.keys( opts ).filter( item => item !== 'country_id' ).forEach( item => {
			delete opts[ item ];
		});

		this.props.getMembers( opts,  1 );
	};

    memberSearch( bypass, options = null, pageId = 1 ) {
		this.props.getMembers( options ? options : this.props.options, pageId );
		browserHistory.push( `/members?page=${ pageId }#topoflist` );
	}

	searchForm(){
		return (
			<SearchForm
				breakpoint={ this.matchMediaBreakpoint }
				onSubmit={ opts => this.memberSearch( false, opts ) }
				description={ <div>Expand your contact book. 40,000 fellow members <br /> are waiting to connect with you.</div> }
				data={ this.props.members }
				advanced={ ( ({ locations, industries, expertise }) => ({ locations, industries, expertise }) )( this.props ) }
				clearForm={ evt => this.clearSearchForm( evt ) }
				membersInfo={this.state.membersInfo[0]}/>
		);
	}

	pagination(){

		const pageLocation = !this.props.location.query.page || !this.props.location.query.page.pageLocation;
		const currentPage = PaginationHelpers.setCurrentPage( !pageLocation ? 1 : this.props.location.query.page, this.props.paging.total_pages );
		const pagination_details = PaginationHelpers.getCurrentPage( currentPage, this.props.paging.total_pages );

		return (
			<Pagination
				location={ this.props.location }
				currentPage={ currentPage }
				pagination={ pagination_details }
				pageNumbers={ PaginationHelpers.getPageNumbers( pagination_details ) }
				totalPages={ this.props.paging.total_pages }
				onPaginationClick={ currentPage => this.memberSearch( true, null, currentPage ) } />
		);
	}

	loader(){
		return (
			<article className="warning members-body">
				<header className="container">
					<div className="row">
						<div className="col-xs-12">
							<Loader/>
						</div>
					</div>
				</header>
			</article>
		);
	}

	render() {
		const condition = !this.props.members || this.props.members === 'Loading' || !this.props.paging || !this.props.locations || !this.props.industries || !this.props.expertise || !this.props.sectors ;

		const member = this.state.membersInfo[0] && this.state.membersInfo[0]
		return (
			<article className="members-body">
				{ this.searchForm() }
				<div className="container theme-page-content-wrapper">
					<div className="row">
						{ member && <div className="col-12 heading-section no-margin">
							<p className="body-copy">{ member && member.member_summary }</p>
						</div>
						}
					</div>
				</div>
				{ condition ? this.loader() : !this.props.members.length ? <NoResults /> : <MemberList members={ this.props.members } /> }
				<section className="container">
					<div className="row">
						<div className="col-xs-12 text-center">
							{ !condition && this.props.paging.total_pages > 1 ? this.pagination() : '' }
						</div>
					</div>
				</section>
			</article>
		);
	}
}

const mapStateToProps = state => ({
	members: state.members.members,
	paging: state.members.pagination,
	locations: state.search.locations,
	expertise: state.search.expertise,
	industries: state.search.industries,
	sectors: state.search.sectors,
	options: state.members.options,
	formValues: state.form.search_form,
});

const mapDispatchToProps = dispatch => ({
	getMembers: ( options, page ) => dispatch( memberActions.getMembers( options, page ) ),
	unmountMembers: ( options, page ) => dispatch( memberActions.unmountMembers( options, page ) ),
	getLocations: () => dispatch( commonActions.getLocations() ),
	getExpertise: () => dispatch( commonActions.getExpertise() ),
	getIndustries: () => dispatch( commonActions.getIndustries() ),
	getSectors: () => dispatch( commonActions.getSectors() ),
});

export default connect( mapStateToProps, mapDispatchToProps )( MemberPage );



// WEBPACK FOOTER //
// src/client/components/site/features/members/pages/MemberPage.js